import Vue from "vue";
import VueRouter from "vue-router";
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    meta: { layout: "empty" },
    component: () => import("../views/Home.vue")
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "empty" },
    component: () => import("../views/Login.vue")
  },
  {
    path: "/profile",
    name: "profile",
    meta: { layout: "user", requiresAuth: true },
    component: () => import("../views/UserPage.vue")
  },
  {
    path: "/admin",
    name: "admin",
    meta: { layout: "user" },
    component: () => import("../views/AdminLogin.vue")
  },
  {
    path: "/panel",
    name: "admin-panel",
    meta: { layout: "admin", requiresAuth: true },
    component: () => import("../views/AdminPanel.vue")
  },
  {
    path: "/thank",
    name: "thank",
    meta: { layout: "thank" },
    component: () => import("../views/ThankYou.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    
    if (store.getters.isLogin) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})

export default router;
